export const isDebug = Boolean(process.env.GATSBY_DEBUG);
export const isBrowser = typeof window !== 'undefined';
export const hasLocalStorage = isBrowser && !!window.localStorage;
